import React, { useState } from 'react';
import { Col, Modal, Button } from 'react-bootstrap';

export const EducationCard = ({ imgSrc, education, startYear, endYear, description }) => {
    const [show, setShow] = useState(false);
    const [activeSection, setActiveSection] = useState(null);

    const handleClose = () => {
        setShow(false);
        setActiveSection(null);
    };
    const handleShow = () => setShow(true);

    const handleSectionClick = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    return (
        <>
            <Col size={12} sm={6} md={4} onClick={handleShow}>
                <section className="schools text-center education-card">
                    <img className="education-img" src={imgSrc} alt={`${education} Logo`} />
                    <h3>{education}</h3>
                    <p>{startYear} - {endYear}</p>
                    <br /><br />
                </section>
            </Col>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{education}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ color: 'black', fontSize: '12px' }}>
                    {education === "Multimedia University" ? (
                        <div>
                            <h5 onClick={() => handleSectionClick('muet')} style={{ cursor: 'pointer', fontSize: '14px' }}>Malaysian University English Test (MUET)</h5>
                            {activeSection === 'muet' && (
                                <p style={{ fontSize: '12px' }}>Band 4.5</p>
                            )}
                            <h5 onClick={() => handleSectionClick('bachelors')} style={{ cursor: 'pointer', fontSize: '14px' }}>Bachelor's Degree in Computer Science (Hons.)</h5>
                            {activeSection === 'bachelors' && (
                                <ul className="left-align" style={{ fontSize: '12px' }}>
                                    <li>Integrity and Leadership</li>
                                    <li>Workplace Communication</li>
                                    <li>Chess</li>
                                    <li>Programming Fundamentals</li>
                                    <li>Calculus</li>
                                    <li>Discrete Structures and Probability</li>
                                    <li>Professional Development</li>
                                    <li>Character Building (St.John Ambulance of Malaysia)</li>
                                    <li>Object-Oriented Programming and Data Structures</li>
                                    <li>Database Fundamentals</li>
                                    <li>Computational Methods</li>
                                    <li>Computer Architecture and Organization</li>
                                    <li>Sports Science</li>
                                    <li>Research Methodology in Computer Science</li>
                                    <li>Appreciation of Ethics and Civilizations</li>
                                    <li>Philosophy and Current Issues</li>
                                    <li>Object-Oriented Analysis and Design</li>
                                    <li>Software Engineering Fundamentals</li>
                                    <li>Operating Systems</li>
                                    <li>Computer Networks</li>
                                    <li>Japanese for Beginners</li>
                                    <li>Data Science Fundamentals</li>
                                    <li>Statistical Data Analysis</li>
                                    <li>Algorithm Design and Analysis</li>
                                    <li>Cryptography and Data Security</li>
                                    <li>Data Mining</li>
                                    <li>Machine Learning</li>
                                    <li>Visual Information Processing</li>
                                    <li>Final Year Project Part 1</li>
                                    <li>Data Visualization</li>
                                    <li>Social Media Computing</li>
                                    <li>Artificial Intelligence</li>
                                    <li>Final Year Project Part 2</li>
                                </ul>
                            )}
                            <h5 onClick={() => handleSectionClick('foundation')} style={{ cursor: 'pointer', fontSize: '14px' }}>Foundation in Information Technology</h5>
                            {activeSection === 'foundation' && (
                                <ul className="left-align" style={{ fontSize: '12px' }}>
                                    <li>Introduction to Computing Technologies</li>
                                    <li>Communicative English</li>
                                    <li>Mathematics 1</li>
                                    <li>Introduction to Business Management</li>
                                    <li>Essential English</li>
                                    <li>Multimedia Fundamentals</li>
                                    <li>Mathematics 2</li>
                                    <li>Problem Solving and Program Design</li>
                                    <li>Critical Thinking</li>
                                    <li>Introduction to Digital Systems</li>
                                    <li>Academic English</li>
                                    <li>Mathematics 3</li>
                                    <li>Principles of Physics</li>
                                    <li>Mini IT Project</li>
                                </ul>
                            )}
                        </div>
                    ) : education === "SMK Rantau Petronas" ? (
                        <div>
                            <h5 onClick={() => handleSectionClick('spm')} style={{ cursor: 'pointer', fontSize: '14px' }}>Malaysian Certificate of Education (SPM)</h5>
                            {activeSection === 'spm' && (
                                <ul className="left-align" style={{ fontSize: '12px' }}>
                                    <li>Malay Language</li>
                                    <li>English Language</li>
                                    <li>Moral Education</li>
                                    <li>History</li>
                                    <li>Mathematics</li>
                                    <li>Additional Mathematics</li>
                                    <li>Physics</li>
                                    <li>Chemistry</li>
                                    <li>Biology</li>
                                </ul>
                            )}
                            <h5 onClick={() => handleSectionClick('pt3')} style={{ cursor: 'pointer', fontSize: '14px' }}>Form Three Assessment (PT3)</h5>
                            {activeSection === 'pt3' && (
                                <ul className="left-align" style={{ fontSize: '12px' }}>
                                    <li>Malay Language</li>
                                    <li>Malay Language (Aural)</li>
                                    <li>English Language</li>
                                    <li>History</li>
                                    <li>Geography</li>
                                    <li>Mathematics</li>
                                    <li>Science</li>
                                    <li>Computer Science Fundamentals</li>
                                </ul>
                            )}
                        </div>
                    ) : education === "SJKC Chee Mong" ? (
                        <div>
                            <h5 onClick={() => handleSectionClick('upsr')} style={{ cursor: 'pointer', fontSize: '14px' }}>Primary School Achievement Test (UPSR)</h5>
                            {activeSection === 'upsr' && (
                                <ul className="left-align" style={{ fontSize: '12px' }}>
                                    <li>Chinese Language (Writing)</li>
                                    <li>Chinese Language (Comprehension)</li>
                                    <li>Malay Language (Writing)</li>
                                    <li>Malay Language (Comprehension)</li>
                                    <li>English Language (Writing)</li>
                                    <li>English Language (Comprehension)</li>
                                    <li>Science</li>
                                    <li>Mathematics</li>
                                </ul>
                            )}
                        </div>
                    ) : (
                        <p>{description}</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}